import $ from 'jquery';

function categorySelected() {
    $('.avantages-type').each(function() {
        $(this).css('display', 'none');
    });
    const category = $('input[type=radio]:checked').val();
    $('.avantages-type').each(function () {
        if ($(this).data('tab') === category) {
            $(this).css('display', 'block');
        }
    });
}

$('input[type=radio]').click(function() {
    $('input[name=questions]:checked').each(function() {
        $(this).prop('checked', false);
    });
    categorySelected();
});

if ($('.avantages-container')) {
    categorySelected();
}
